import { Xid } from 'xid-ts'
import {
    PersonalScheduleList,
    PersonalScheduleProgramHistory,
    PersonalScheduleProgramHistoryKind
} from '.'

export function NewPersonalScheduleList(
    date: number,
    lessonId: string
): PersonalScheduleList {
    return {
        id: new Xid().toString(),
        date,
        lessonId
    }
}

/**
 * A history entry of `kind` for `referenceId` (an exercise, schedule day or
 * programme id). Finishing and cancelling kinds are stamped with their time.
 */
export function newHistory(
    kind: PersonalScheduleProgramHistoryKind,
    referenceId: string,
    meta?: any
): PersonalScheduleProgramHistory {
    const now = Date.now()
    return {
        id: new Xid().toString(),
        kind,
        startedAt: now,
        referenceId,
        setsFinishTime: [],
        meta,
        ...(kind === 'workout.finished' && { finishedAt: now }),
        ...(kind.endsWith('.cancelled') && { cancelledAt: now })
    }
}
